import { Link } from "react-router-dom";
import styled from "styled-components";
import useCloudinaryImages from "../hooks/useCloudinaryImages";
import { device } from "../breakpoints";

// ⚠️ 참고: device 객체는 이미 전역에서 가져온다고 가정합니다.
// import { device } from "../breakpoints";

const Container = styled.div`
    width: 100%;
    height: 100%;
    box-sizing: border-box;

    @media ${device.desktop} {
        padding: 0 20px;
    }
    @media ${device.laptop} {
        padding: 0 20px;
    }
    @media ${device.tablet} {
        padding: 0 20px;
    }
    @media ${device.mobile} {
        padding: 0 20px;
    }
`;

const TitleMain = styled.div`
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    height: auto;
`;

// ----- 텍스트 스타일 반응형 적용 -----
const TitlePoint = styled.p`
    font-family: "JejuHallasan";
    font-style: normal;
    font-weight: 400;
    font-size: 128px;
    text-align: center;
    margin-top: 120px;

    @media ${device.desktop} {
        font-size: 100px;
        margin-top: 100px;
    }
    @media ${device.laptop} {
        font-size: 80px;
        margin-top: 80px;
    }
    @media ${device.tablet} {
        font-size: 64px;
        margin-top: 60px;
    }
    @media ${device.mobile} {
        font-size: 48px;
        margin-top: 40px;
    }
`;
const Title = styled.h1`
    font-size: 48px;
    text-align: center;
    margin-top: 50px;

    @media ${device.laptop} {
        font-size: 42px;
        margin-top: 40px;
    }
    @media ${device.mobile} {
        font-size: 28px;
        margin-top: 30px;
    }
`;
const TitleDes = styled.h1`
    font-size: 20px;
    text-align: center;
    margin-top: 40px;
    line-height: 1.6;

    @media ${device.laptop} {
        font-size: 20px;
        margin-top: 30px;
    }
    @media ${device.mobile} {
        font-size: 16px;
        margin-top: 20px;
    }
`;
const TitleDesP = styled.p`
    font-size: 16px;
    color: #808080;
    line-height: 1.4;

    @media ${device.mobile} {
        font-size: 14px;
    }
    @media ${device.laptop} {
        font-size: 18px;
    }
    @media ${device.tablet} {
        font-size: 20px;
    }
    @media ${device.mobile} {
        font-size: 14px;
    }
`;

// ----- 시장 규모 섹션 반응형 적용 -----
const MarketShare = styled.div`
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    height: auto;
`;
const MarketTitle = styled.h2`
    font-size: 48px;
    text-align: center;
    margin-top: 180px;

    @media ${device.laptop} {
        font-size: 38px;
        margin-top: 120px;
    }
    @media ${device.mobile} {
        font-size: 28px;
        margin-top: 80px;
    }
`;

const MarketImgC = styled.div`
    display: flex;
    gap: 120px;
    align-items: flex-start; /* 이미지가 위에서 정렬되도록 변경 */
    justify-content: center;
    margin-top: 80px;

    @media ${device.laptop} {
        gap: 60px;
        margin-top: 60px;
    }
    @media ${device.tablet} {
        flex-direction: column; /* 태블릿부터 세로 정렬 */
        gap: 40px;
        margin-top: 40px;
    }
    @media ${device.mobile} {
        flex-direction: column;
        gap: 30px;
        margin-top: 30px;
    }
`;

const MarketImgW = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 500px; /* 데스크톱/랩탑에서 최대 너비 제한 */

    @media ${device.tablet} {
        gap: 30px;
        align-items: center; /* 태블릿/모바일에서 중앙 정렬 */
        max-width: 100%;
    }
    @media ${device.mobile} {
        gap: 20px;
    }
`;

// ----- 주류 역사 섹션 반응형 적용 -----
const AlcoholSort = styled.div`
    width: 100%;
    height: 550px;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;

    @media ${device.laptop} {
        height: 450px;
    }
    @media ${device.tablet} {
        height: auto;
        padding: 80px 0;
    }
    @media ${device.mobile} {
        height: auto;
        padding: 30px 0;
        margin-top: 60px;
    }
`;

const AlcoholWrapper = styled.div`
    width: 100%;
    height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 60px;

    @media ${device.desktop} {
        max-width: 900px;
        gap: 40px;
    }
    @media ${device.laptop} {
        max-width: 700px;
        gap: 30px;
        height: 300px; /* 원 크기에 맞게 높이 조정 */
    }
    @media ${device.tablet} {
        height: auto;
        gap: 20px;
        max-width: 500px;
    }
    @media ${device.mobile} {
        flex-direction: column; /* 모바일에서는 세로로 나열 */
        height: auto;
        gap: 20px;
    }
`;

const Overlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s ease;
    color: white;
    font-size: 20px;
    font-weight: bold;

    @media ${device.mobile} {
        font-size: 16px;
    }
`;

// 원형 이미지 컴포넌트의 크기 반응형 조정
const BaseAlcoholCircle = styled.div`
    position: relative;
    width: 300px;
    height: 300px;
    background-color: #fff;
    border-radius: 50%;
    overflow: hidden;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
    transition: transform 0.3s ease;

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0 15px 25px rgba(0, 0, 0, 0.3);

        .overlay {
            opacity: 1;
        }
    }

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    @media ${device.laptop} {
        width: 230px;
        height: 230px;
    }
    @media ${device.tablet} {
        width: 200px;
        height: 200px;
    }
    @media ${device.mobile} {
        width: 200px;
        height: 200px;
    }
`;

const Soju = styled(BaseAlcoholCircle)``;
const Beer = styled(BaseAlcoholCircle)``;
const Makgeolli = styled(BaseAlcoholCircle)``;

export default function Story() {
    const { imageSrc, loading, error } = useCloudinaryImages([
        "korea",
        "global_jlfeks",
        "jinro_bexnug",
        "hite_an9nj4",
        "jipeng_ugwtwn",
    ]);

    if (loading) return <p>이미지를 불러오는 중...</p>;
    if (error) return <p>에러: {error}</p>;

    return (
        <Container>
            <TitleMain>
                <TitlePoint>,</TitlePoint>
                <Title>사이트 제작 의도</Title>
                <TitleDes>
                    사이트를 제작 한 이유는 평소 주류에 관심이 많았고 최근에
                    새로운 술이 많이 나왔는데요. 많은 사람들이 새로운 제품을
                    알지 못하고 도수는 어느 정도인지 무슨 맛인지를 모르는 상태로
                    주류를 고르는 것에 불편함을 직접 느끼게 되었습니다.
                </TitleDes>
                <TitleDes>
                    주류에 관하여 이야기를 해보면 많은 사람들이 술 종류가
                    많으니까 다 똑같은 술이라고 생각하고 드시는 분들도 꽤 많이
                    계셔가지고 술 종류도 소개할 겸 더 나아가 외국인 분들에게
                    한국 술에 대해서 알려드리고 싶어서 제작하게 되었습니다.
                </TitleDes>
            </TitleMain>
            <MarketShare>
                <MarketTitle>주류 시장 규모</MarketTitle>
                <MarketImgC>
                    <MarketImgW>
                        {imageSrc[0] && (
                            <img
                                src={imageSrc[0]}
                                alt="대한민국 주류 시장 규모 그래프"
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "contain",
                                }}
                            />
                        )}
                        <TitleDesP>
                            2022년 기준 출고 금액 기준으로 10조 원에 육박하며,
                            전년 대비 12.9% 증가했습니다.
                        </TitleDesP>
                    </MarketImgW>
                    <MarketImgW>
                        {imageSrc[1] && (
                            <img
                                src={imageSrc[1]}
                                alt="글로벌 주류 시장 규모 그래프"
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "contain",
                                }}
                            />
                        )}
                        <TitleDesP>
                            새로운 보고서에 따르면 세계 주류 시장 규모는
                            2032년까지 2조 7,400억 달러
                            <br />
                            (한화 약 3,785조 8,580억 원)에 도달하며 견고한
                            성장을 경험할 것으로 전망된다.
                            <br />
                        </TitleDesP>
                    </MarketImgW>
                </MarketImgC>
            </MarketShare>
            <MarketTitle>주류의 역사 알아보기</MarketTitle>
            <AlcoholSort>
                <AlcoholWrapper>
                    <Link to="/story/soju">
                        <Soju>
                            {imageSrc[2] && (
                                <img
                                    src={imageSrc[2]}
                                    alt="진로 소주"
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover", // cover로 변경하여 원 안에 꽉 차게 함
                                    }}
                                />
                            )}
                            <Overlay className="overlay">소주의 역사</Overlay>
                        </Soju>
                    </Link>
                    <Link to="/story/beer">
                        <Beer>
                            {imageSrc[3] && (
                                <img
                                    src={imageSrc[3]}
                                    alt="하이트 맥주"
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                    }}
                                />
                            )}
                            <Overlay className="overlay">맥주의 역사</Overlay>
                        </Beer>
                    </Link>
                    <Link to="/story/makgeolli">
                        <Makgeolli>
                            {imageSrc[4] && (
                                <img
                                    src={imageSrc[4]}
                                    alt="지평 생막걸리"
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                    }}
                                />
                            )}
                            <Overlay className="overlay">막걸리의 역사</Overlay>
                        </Makgeolli>
                    </Link>
                </AlcoholWrapper>
            </AlcoholSort>
        </Container>
    );
}
